import { render, staticRenderFns } from "./PaymentTypeDisplay.vue?vue&type=template&id=0654259c&"
import script from "./PaymentTypeDisplay.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports